export default __webpack_public_path__ + "static/media/kitchen4-afterD-480w.048aa0b5.avif";